export default __webpack_public_path__ + "static/race-religion-secularism-c0dcd5046d9b475d6983cbd4c0553d3a.png";